import { TimeOfDayProvider } from '../TimeOfDayProvider';
import { CompositeLAANCAdvisoryProvider } from './laanc/CompositeLAANCAdvisoryProvider';
import { MissionFeatureCollectionFacade } from './MissionFeatureCollectionFacade';
import { IPersistableMissionFeatureCollection, PersistableMissionFeatureCollection } from './PersistableMissionFeatureCollection';

export class MissionFeatureCollectionFacadeAdapter {
    static inject = () => [
        CompositeLAANCAdvisoryProvider,
        TimeOfDayProvider
    ]
    constructor(
        private compositeLAANCAdvisoryProvider: CompositeLAANCAdvisoryProvider,
        private timeOfDayProvider: TimeOfDayProvider
    ){}

    adapt = (mission: PersistableMissionFeatureCollection): MissionFeatureCollectionFacade => {
        return new MissionFeatureCollectionFacade(mission, this.compositeLAANCAdvisoryProvider, this.timeOfDayProvider);
    }
    adaptFromPersisted = (mission: IPersistableMissionFeatureCollection): MissionFeatureCollectionFacade => {
        return new MissionFeatureCollectionFacade(new PersistableMissionFeatureCollection(mission), this.compositeLAANCAdvisoryProvider, this.timeOfDayProvider);
    }
}
